import { Fireworks } from 'fireworks-js';

(function (angular) {
	var DEFAULT_FIREWORKS_TIMEOUT = 10000;
	var fireworksInstance = null;
	var container = null;

	angular.module('bizPartEngage').provider('fireworks', fireworksProvider);

	function fireworksProvider() {
		var showingFireworks = false;

		function showFireworks(timeout) {
			if (!showingFireworks) {
				// Create container
				container = document.createElement('div');
				container.className = 'fireworks';
				container.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999;';
				document.body.appendChild(container);

				// Initialize fireworks-js
				fireworksInstance = new Fireworks(container, {
					autoresize: true,
					opacity: 0.5,
					acceleration: 1.02,
					friction: 0.97,
					gravity: 1.5,
					particles: 60,
					traceLength: 3,
					traceSpeed: 10,
					explosion: 6,
					intensity: 30,
					flickering: 50,
					lineStyle: 'round',
					hue: {
						min: 0,
						max: 345
					},
					delay: {
						min: 30,
						max: 60
					},
					rocketsPoint: {
						min: 50,
						max: 50
					},
					lineWidth: {
						explosion: {
							min: 1,
							max: 4
						},
						trace: {
							min: 0.1,
							max: 1
						}
					},
					brightness: {
						min: 50,
						max: 80
					},
					decay: {
						min: 0.015,
						max: 0.03
					},
					mouse: {
						click: false,
						move: false,
						max: 1
					}
				});

				fireworksInstance.start();
				showingFireworks = true;

				setTimeout(hideFireworks, timeout || DEFAULT_FIREWORKS_TIMEOUT);
			}
		}

		function hideFireworks() {
			if (container) {
				container.classList.add('fade');
			}

			setTimeout(function () {
				if (fireworksInstance) {
					fireworksInstance.stop();
					fireworksInstance = null;
				}
				if (container && container.parentNode) {
					container.parentNode.removeChild(container);
					container = null;
				}
				showingFireworks = false;
			}, 1500);
		}

		return {
			showFireworks: showFireworks,
			hideFireworks: hideFireworks,
			$get: function () {
				return {
					show: showFireworks,
					hide: hideFireworks
				};
			}
		};
	}
})(window.angular);
